import { CommonModule } from '@angular/common'
import { RendererFactory2,Renderer2,ElementRef, ChangeDetectorRef, Compiler, Component, ComponentRef, EventEmitter, Injector, Input, NgModule, NgModuleRef, OnInit, Output, ViewChild, ViewContainerRef,HostListener } from '@angular/core'
import { FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors,Validators,FormControl } from '@angular/forms'
import {
	MatAutocompleteModule, MatButtonModule, MatCardModule, MatCheckboxModule,
	MatDatepickerModule, MatDialogModule, MatExpansionModule, MatFormFieldModule, MatGridListModule, MatIconModule, MatInputModule, MatMenuModule, MatRadioModule, MatSelectModule, MatTableDataSource, MatTableModule
} from '@angular/material'
import { RouterModule } from '@angular/router'
import * as _ from 'lodash'
import { Subject,Observable } from 'rxjs'
import { Stringable, StringableValues } from '../../../common/stringable.decorator'
import { MustStringable } from '../../../Interfaces/MustStringable'
import { DialogService, StateService, UtilitaryService } from '../../../services'
import { FormAtylBase } from '../../form-atyl-base'
import { FormAtylControlService } from '../../form-atyl-control.service'
import { FormAtylService } from '../../form-atyl.service'
import { FormAtylInputModule } from '../form-atyl-input/form-atyl-input.module'
import { ConfirmComponent } from '../form-dialog/confirm/confirm.component'
import { FormDialogErrorsComponent } from '../form-dialog/form-dialog-errors/form-dialog-errors.component'
import { TableAtylDisplayModule } from '../form-table-atyl-display/table-atyl-display.module'
import { ViewportScroller } from '@angular/common';
import { Router, Scroll, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { FormAtylInputComponent } from '../form-atyl-input/form-atyl-input.component'

import { AtylService } from '../../service/atyl.service'
import { JSONRpcResponse } from '../../../Interfaces/JSONRpcResponse'
import { MatSnackBar } from '@angular/material/snack-bar'

import { IaDialogComponent } from '../../../views/partials/content/ia/dialog/ia-dialog.component'

//import { serialize } from 'chartist'
import * as moment from 'moment'

/*
import * as smoothscroll from 'smoothscroll-polyfill';
if (typeof window !== "undefined") {
          console.log('polyfilled');
          smoothscroll.polyfill();
         // window.__forceSmoothScrollPolyfill__ = true;
}
*/
const KEY = 'form-atyl-component'

@Component({
	selector: 'app-form-atyl',
	templateUrl: './form-atyl.component.html',
	styleUrls: ['./form-atyl.component.scss']
})
@Stringable({
	path: 'motor-form-atyl/form-atyl-components/form-atyl',
	key: KEY
})
export class FormAtylComponent implements OnInit, MustStringable {
	@ViewChild('atylMoteur', { read: ViewContainerRef, static: false }) atylMoteur: ViewContainerRef
    @ViewChild('atylMoteurForm', { read: undefined, static: false }) myScrollContainer: ElementRef;
 	
 	@ViewChild('submitBtnSave', { read: ElementRef , static: false }) btnSave: ElementRef;
    @ViewChild('submitBtnSaveClose', { read: ElementRef , static: false }) btnSaveClose: ElementRef;


	@StringableValues(KEY) strings: any

	@Input() color: string
	@Input() creationForm: string
	@Input() atylComponents: string
	@Input() atylTemplate: any
	@Input() atylDocuments: string
	@Input() submited = new EventEmitter<any>()
	@Input() isEditable: boolean
	@Input() status: any
	@Input() avis: any
	@Input() prevButton: boolean
	@Input() nextButton: boolean
	@Input() saveButton: boolean
	@Input() indexSousForm: any
	@Input() tiers: any = null
	@Input() dossier: any = null
	@Input() curentForm: any
	@Input() currentParentForm: any
	@Input() curentSection = new EventEmitter<any>()
    @Input() saveTriggerSubject: Subject<any>;
	
	@Output() loaded = new EventEmitter<boolean>()
	@Output() submit = new EventEmitter<any>()
	
	@Output() valid = new EventEmitter<any>()
	
	@Output() ready = new EventEmitter<any>()
	
	@Output() changed = new EventEmitter<any>();
	@Input() valided:EventEmitter<any> = new EventEmitter<any>()
	@Input() showErrors:EventEmitter<any> = new EventEmitter<any>()
		
	@Input() clickedAction:boolean = false;
	@Input() buttonAction:boolean=true;
	
	@Input() locked:Boolean=false;
	@Input() whoLocked:any={};
	
	predValue:any;
	
	
	@Input() demande_date_debut:any
	@Input() demande_date_fin:any
    
	onsubmited: boolean = false
	submitedSuccess: boolean = false
    
    @Input() multiform:boolean=false;
    
    @Input() isNomade:boolean=false;
	
	documents: any
	files: any = []
	atylInputsControls: FormAtylBase<any>[]
	observer: Subject<any> = new Subject()
	form: FormGroup = new FormGroup({})
	controls: any[] = []
	payLoad = '';
	cmpRef: ComponentRef<any>
	navigation: any[] = []
	error: string
	currentEtat: any = '1'
	//currentAvis: any = '0';

	data: any[] = []
	documentSelect: any
	typeDocumentSelect: any
	documentFile: any

	listDocument: any = {
		rows: [],
		columns: [
			{ id: 'download', label: 'Télécharger' },
			{ id: 'document', label: 'Document' },
			{ id: 'typeDocument', label: 'Type de document' },
			{ id: 'nonvalide', label: 'Non validé' },
			{ id: 'valide', label: 'Validé' }
		]
	};
	listDocumentSelect: any[] = []
	listTypeDocumentSelect: any[] = []
	// formHeight: string = '75vh'
	formHeight: string = '70vh'
    
	debutLibelle: string = "Date Examen/début"
	finLibelle: string = "Date fin"
	shouldDisplayFin: boolean = true

	dataSource = new MatTableDataSource()
	user: any
	update_begin:boolean=true;
	
	 dialogContainer:any;
	
	validatedSubscription:any;

	@Output() dateChange = new EventEmitter<{value: Date, type: String}>();
	@Input() ageDebutForm: String;
	@Input() iaButton:boolean=false;
	
	appSubscribe:any;
	
	constructor(
		private rendererresolveComponentFactory: RendererFactory2,
		private acs: FormAtylControlService,
		private formAtylService: FormAtylService,
		private compiler: Compiler,
		private injector: Injector,
		private moduleRef: NgModuleRef<any>,
		private utilities: UtilitaryService,
		private stateService: StateService,
		private changeDetectorRef: ChangeDetectorRef,
		private dialogService: DialogService,
		private viewportScroller: ViewportScroller,
	     private router: Router,
		private atylService: AtylService,
		private snackbar: MatSnackBar,
	) { }

	ngOnInit() {
        
        //this.demande_date_debut=new Date();
       //  this.demande_date_fin=new Date();
         console.log("FormAtylComponent ngOnInit",this.isEditable,this.locked,this.whoLocked);
        this.router.events.pipe(filter(e => e instanceof Scroll)).subscribe((e: any) => {
          console.log(e);
    
          // this is fix for dynamic generated(loaded..?) content
          setTimeout(() => {
            if (e.position) {
              this.viewportScroller.scrollToPosition(e.position);
            } else if (e.anchor) {
              this.viewportScroller.scrollToAnchor(e.anchor);
            } else {
              this.viewportScroller.scrollToPosition([0, 0]);
            }
          });
        });
        
		this.loaded.emit(false)
		//console.log("FormAtylComponent init",this.dossier,this.tiers)
		this.atylInputsControls = this.formAtylService.getAtylInputs(this.atylComponents,this.dossier,this.tiers)
		this.form = this.acs.toFormGroup(this.atylInputsControls)
		this.dataSource.data = this.listDocument.rows

		this.form.addControl('uuid', new FormControl(this._newGuid(),Validators.required));
		this.form.addControl('pickerDateBegin', new FormControl(Validators.required));

		this.submited.subscribe((item: any) => this.onSubmited(item))
		this.__createComponent__orShow__error()
		this.currentEtat = this.status
		if (!this.isEditable)
			this.form.disable()

		this.stateService.user.subscribe((user: any) => {
			this.user = user
		})
		console.log('FormAtylComponent',this.form);
		if (this.currentParentForm!=undefined
		&& this.currentParentForm.form!=undefined
		) {
			const dateForm = this.currentParentForm.form.date_form
	
			this.debutLibelle = dateForm.debut_libelle
			this.finLibelle = dateForm.fin_libelle
			
        	this.shouldDisplayFin = dateForm.is_fin
        }
        /*
        document.addEventListener('DOMContentLoaded', () => {
  			console.log("FormAtylComponent lifecycle DOMContentLoaded");
		});*/
		
		this.loaded.subscribe((load:any) =>{
			console.log("FormAtylComponent lifecycle DOMContentLoaded",load);
			
			if (load) 
				this._ngAfterViewChecked();
				
		})
		
		
		this.showErrors.subscribe((show:any) =>{
					this.__show__error__dialog__();
						
		})


        if(this.saveTriggerSubject != undefined && this.saveTriggerSubject){
            this.saveTriggerSubject.subscribe((indexTabClicked) => {
                if(this.indexSousForm == indexTabClicked){
                    this.onValidate({disabled:null,action:""});
                }
            });
        }
		
		
		
	}
	
	
	private _newGuid() {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
				var r = Math.random() * 16 | 0,
					v = c == 'x' ? r : (r & 0x3 | 0x8)
				return v.toString(16)
			})
		}
	
	private __createComponent__orShow__error() {
		if (this.atylTemplate && this.atylInputsControls) {
			this.createComponentFromRaw(this.atylTemplate, this.atylInputsControls, this.form,this.stateService)
		}
		else if (!this.atylTemplate && !this.atylInputsControls) {
			this.error = `Aucun champs ni template ont été trouvé, veuillez générer le formulaire par l'interface d'admin.`
		} else if (!this.atylTemplate) {
			this.error = `Aucun template de formulaire n'a été trouvé, veuillez en générer un.`
		}
		else if (!this.atylInputsControls) {
			this.error = `Aucun champs de formulaire n'a été trouvé, veuillez en créer les champs correspondant au template.`
		}
	}

	

	afterNextRender() {
		console.log("FormAtylComponent lifecycle afterNextRender");
	}
	
	ngAfterViewChecked() {
		
		if (this.validatedSubscription==undefined)
			this.validatedSubscription=this.valided.subscribe((validation:any) =>{
				
				
				let btn:any= (validation.close)
						?	this.btnSaveClose.nativeElement
					 	:
					 	this.btnSave.nativeElement;
						console.log("valided click",validation,this.clickedAction,btn.disabled)
				if (validation.validate!=undefined
				 && validation.validate
				
				 ) {
					 
					 this.clickedAction=true;
					 console.log("valided button ",this.btnSaveClose,this.btnSave,this.clickedAction)
					 btn.click();
					
					 
				}
			});
		//cdk-overlay-pane animate__animated animate__slideInDown
		
		 this.dialogContainer = document.querySelector('.cdk-global-overlay-wrapper > .cdk-overlay-pane')
		if (this.dialogContainer) {
			
			this.dialogContainer.addEventListener('resize', this.onResized(this));
		}	
	}	
	
	_ngAfterViewChecked() {
		
		
		
		if (this.curentForm!=undefined &&  this.curentForm.customBehaviour!=undefined
                  && this.curentForm.customBehaviour
                  ) {
        //   this.form.updateValueAndValidity({ onlySelf: false, emitEvent: true });       
           	console.log("FormAtylComponent lifecycle ngAfterViewChecked");

           Object.keys(this.form.controls).forEach((ctlID) => {
			     if (this.update_begin) {
				       let etl:any=this.form.get(ctlID);
				       console.log("ngAfterContentInit",etl,etl.value)
				     //if (ctlID=="7339")
				       
				       	etl.setValue(etl.value);
				       	this.update_begin=false;
				      } 
				      	
			      })     
              this.changeDetectorRef.detectChanges();      
        } else
        	this.update_begin=false;
        
       
	
	}
	 
	ngAfterViewInit() {
		
		
		/*
		const dialogContainer = document.querySelector('.cdk-overlay-pane')
		if (dialogContainer) {
			
			dialogContainer.addEventListener('resize', this.onResized(this));
			
			this.formHeight = (dialogContainer.clientHeight - 165) + 'px'
			dialogContainer.addEventListener('resize', (e) => {
				this.formHeight = (dialogContainer.clientHeight - 165) + 'px'
			})
		}*/
		//this.changeDetectorRef.detectChanges()
		
		 const vl=this.form.valueChanges.subscribe(selectedValue  => {
                //  console.log('form value changed');
                //  console.log('form value changed',this.curentForm,selectedValue);
                  
                  /*
                     let changed:boolean=false;
					 var defaultv:any={};
					 this.curentForm.fields.forEach(field => {
					 let s:string=(field.value) ? JSON.stringify(field.value) :  null;
					 if (field.field.type=="date")
					    s=JSON.stringify(moment.parseZone(field.value));
						 defaultv[field.ID]=s;
					 });
					 
					 
					 Object.keys(selectedValue).forEach(id => {
						 let val:any=(selectedValue[id]) ? JSON.stringify(selectedValue[id]): null;
						 if (val) {
							 let re:any=/^[0-9]{4}-[0-9]{2}-[0-9]{2}/;
							 if (val.match(re))
							    val=JSON.stringify(moment.parseZone(selectedValue[id]));
						 }	    
			             if (defaultv[id]!=undefined
			              && defaultv[id]!=val ) {
			                changed=true;
			                console.log("valueChanges",id,defaultv[id],val)
			              }
					 })
					 */
					 let formformated = this.form.getRawValue()
					// formformated['change_value'] = changed
						formformated['etat'] = this.currentEtat
						formformated['demande_date_debut'] = this.demande_date_debut;
						formformated['demande_date_fin'] = this.demande_date_fin;
                  let changed:boolean=false;
                 // if (this.form.valid) {
					  
					  if (this.predValue!=JSON.stringify(formformated)) {
					       this.predValue=JSON.stringify(formformated);
					       changed=true;
						  if (this.predValue) {
							/*if (this.form.invalid)
								this.__show__error__dialog__()*/
							
						     console.log("valueChanges", this.predValue,formformated)
						   	this.changed.emit({"data":formformated,
							    "valid":this.form.valid,
							    "controls":this.form.controls});
						  } 
						  
						 
					  }
				//  }
			   	  formformated["dossier"]=this.dossier;
			   	 	
                  let oform:any=this;
                  
                  if (changed && this.curentForm!=undefined &&  this.curentForm.customBehaviour!=undefined
                  && this.curentForm.customBehaviour
                  ) {
                   
                    try {
                        var js=this.curentForm.customBehaviour;
                        js+="\ncustomBehavior();"
                       eval(js);
                         //console.log('form value changed',js);
                    }
                   catch (err) {
                       console.log("error customBehaviour",err,this.curentForm.customBehaviour)
                    }
                    
				   
                    
                }
             
					 
					 
			
			//	}
                
                
         })
         
		
	}
	
	_getSnackbar(message:string,duration:number=5000) {
				let snackBarRef = this.snackbar.open(message,'', {
					 duration: duration
				});
	}
	
	_getCheck(fn:any,options: any = {},method:string="doublon") {
		if (this.curentForm!=undefined) {
			console.log("_getCheck",this.curentForm,fn);
			this.appSubscribe=this.atylService.getCheckFormulary(this.curentForm.ID,options,method).subscribe((res:JSONRpcResponse)=>{
				fn(res);
			});
		}
	}
	
	_getField(id:any) {
		let field:any=null;
		if (this.form!=undefined && this.form
		&& this.form.get(id))
		 	field=this.form.get(id);
		 	
		return field;
     }
	
	_getValue(id:any) {
		let val:any=null;
		
		let field:any=this._getField(id);
		if (field) 
		 	val=field.value;
		
		return val;
		
	}
	
	_setValue(id:any,value:any,emitEvent:boolean=false) {
		let val:any=null;
		let setted:boolean=false;
		let field:any=this._getField(id);
		if (field)
		  {
			  field.setValue(value, { emitEvent: emitEvent })
			  setted=true;
		 }
		
		
		return setted;
		
	}
	
	
	onResized(event: any): void {
    	
		//console.log("onResized before",event,this.formHeight);
		let sizeH:number=(this.isNomade) ? 205 :165;
		if (this.dialogContainer) {
			
			
			this.formHeight = (this.dialogContainer.clientHeight - sizeH) + 'px'
			
			this.dialogContainer.addEventListener('resize', (e) => {
				this.formHeight = (this.dialogContainer.clientHeight - sizeH) + 'px'
			})
			this.dialogContainer.removeEventListener('resize',null);
			//console.log("onResized after",event,sizeH,this.formHeight,this.dialogContainer);
		}
	
		//this.changeDetectorRef.detectChanges()
  	}
  	 
    ngAfterContentInit() {
        /*
        this.scrolled.subscribe((elt:any)=> {
            
             
            
             let elt2=document.getElementById(elt.element.id);
             let element:HTMLElement = elt2 as HTMLElement;
             this.myScrollContainer.nativeElement.scrollTop=element.offsetTop;
              console.log("scrolled event",element);
             //this.myScrollContainer.nativeElement.scrollTop=(elt.size) ? elt.size:  element.offsetTop;
            // this.changeDetectorRef.detectChanges()
             
        }) 
        */
      	
       
    }

	private createComponentFromRaw(template: string, atylInputsToPass: FormAtylBase<any>[], formToPass: FormGroup, stateService: StateService) {
		// Let's say your template looks like `<h2><some-component [data]='data'></some-component>`
		// As you see, it has an (existing) angular component `some-component` and it injects it [data]

		// Now we create a new component. It has that template, and we can even give it data.

		//let tplate:string='<div clss="tplForm" (onReadyEvent)="onReadyEvent($event)"> '  +template + '</div>';
		let tplate:string=template;
		
		const tmpCmp = this.__create__tmp__component__(tplate, atylInputsToPass, formToPass,stateService)

		// Now, also create a dynamic module.
		const tmpModule = this.__create__tmp__module__(tmpCmp)

		// Now compile this module and component, and inject it into that #atylMoteur in your current component template.
		this.__compile__module__(tmpModule)
	}

	private __create__tmp__component__(template: string, atylInputsToPass: FormAtylBase<any>[], formToPass: FormGroup, stateService: StateService) {
		
		let cp:FormAtylComponent=this;
		
		
		return Component({ template })(class {
			// the class is anonymous. But it's a quite regular angular class. You could add @Inputs,
			// @Outputs, inject stuff etc. // <== no this is a lie.
			atylInputsControls: FormAtylBase<any>[]
			form: FormGroup
			component: any
			observer: Subject<any> = new Subject();
			curentSection=new EventEmitter<any>();
			cp:FormAtylComponent;
			constructor(
               
                
            ) {
				this.atylInputsControls = atylInputsToPass
				this.form = formToPass
				this.cp=cp
				
				//this.cp.onReadyEvent().subscribe(res => this.observeChanged(res));
				
			}
			
			filterListComponent(listComponents: FormAtylBase<any>[], value: string): any {
			
				listComponents.forEach((component, index) => {
					if (component && component.ID === value)
						this.component = component
				})
				return this.component
			}
			observeChanged(observesComponent: any) {
                console.log("observeChanged",observesComponent)
                stateService.updateObservedField(observesComponent);
				this.observer.next(observesComponent)
				
			}
			
			onReadyEvent(event:any) {
				console.log("onReadyEvent.0",event)
				this.cp.ready.emit(event);
			}
			
			
		})
	}

	
	
	
	private __compile__module__(tmpModule: any) {
		this.compiler.compileModuleAndAllComponentsAsync(tmpModule)
			.then((factories) => {
				const f = factories.componentFactories[factories.componentFactories.length - 1]
				this.cmpRef = f.create(this.injector, [], null, this.moduleRef)
				this.cmpRef.instance.name = 'dynamic-form-atyl'
				this.atylMoteur.insert(this.cmpRef.hostView)
				this.loaded.emit(true)
				console.log("__compile__module__",this.cmpRef)
				let sizeTotal=0;
				
				
				_.forEach(document.getElementsByTagName('app-form-atyl')[0].getElementsByTagName('mat-card'), (element, index) => {
					
					let ell=element as HTMLElement 
					
					this.navigation.push({
						id: element.id,
						label: element.getElementsByTagName('mat-card-title')[0].innerHTML,
						
					})
					
					//console.log("__compile__module__ element",this.curentSection,element,ell)
					/*
					if (this.curentSection!=undefined
					&& this.curentSection.id==element.id) {
                        console.log("curentSection scroll",this.curentSection,ell.offsetTop,ell.scrollHeight,ell)
                        //this.myScrollContainer.nativeElement.scrollTop=ell.offsetTop;
                        let elmt={
                            element: ell,
                            size: sizeTotal,
                            scroll: this.myScrollContainer
                        }
                        this.scrolledinternal.emit(elmt);
                    }
                    sizeTotal+=ell.clientHeight;
					*/
				})
				
				
				
			})
	}

	
	private __create__tmp__module__(tmpCmp: any) {
		return NgModule({
			imports: [
				CommonModule,
				RouterModule,
				ReactiveFormsModule,
				FormsModule,
				MatCardModule,
				MatGridListModule,
				MatFormFieldModule,
				MatInputModule,
				MatCheckboxModule,
				MatDatepickerModule,
				MatRadioModule,
				MatSelectModule,
				MatTableModule,
				MatAutocompleteModule,
				MatIconModule,
				MatButtonModule,
				MatDialogModule,
				MatExpansionModule,
				MatMenuModule,
				TableAtylDisplayModule,
				FormAtylInputModule
			],
			declarations: [
				tmpCmp
			],
			entryComponents: [],
			providers: [
				{ provide: FormAtylService, useValue: this.formAtylService }
			]
		})(class { })
	}

	// Cleanup properly. You can add more cleanup-related stuff here.
	ngOnDestroy() {
		if (this.cmpRef) {
			this.cmpRef.destroy()
		}
		
		
		if (this.dialogContainer) {
			this.dialogContainer.removeEventListener('resize',null);
			this.dialogContainer=undefined;
        }
		
		if (this.appSubscribe!=undefined)
			this.appSubscribe.unsubscribe();
		
	}
	onSubmit(btn: any) {
		btn.disabled = true
		let formformated = this.form.getRawValue()
		if (this.form.invalid) {
			this.utilities.log(this.form.errors)
			// open error dialog
			this.dialogService.open(FormDialogErrorsComponent, {
				data: this.getFormValidationErrors(this.form.controls)
			})
		}
		else {
			formformated['NOWORKFLOW'] = true
			this.submit.emit(formformated)
			this.onsubmited = true
			this.utilities.log(JSON.stringify(this.form.getRawValue()))
			btn.disabled = false
		}
	}
	triggerFormValidation(formGroup: any): void {
	    for (const key in formGroup.controls) {
	        const control = formGroup.controls[key];
	
	        if (!control.controls) { // FormControl case
	            control.markAsTouched(); // trigger changes check
	        } else { 
	            this.triggerFormValidation(control); // FormGroup case
	        }
	    }
}
	onValidate(btn: any, action?: any) {
		btn.disable = true
		
		this.triggerFormValidation(this.form);
		
		let formformated = this.form.getRawValue()
		formformated['etat'] = this.currentEtat
		formformated['demande_date_debut'] = this.demande_date_debut;
		formformated['demande_date_fin'] = this.demande_date_fin;
		
		console.log('demande_date',this.demande_date_debut,this.demande_date_fin);
		if (this.form.invalid) {
			this.__show__error__dialog__()
		}
		else {
			let toConfirm = false
			if (toConfirm) {
				this.__show__confirm__dialog__(action, formformated, btn)
			}
			else {
				formformated['NOWORKFLOW'] = false
				this.__handel__form__navigation__(formformated, action)
				this.__do__submit__data(formformated, btn)
			}
		}
		this.valid.emit({"form":this.form,
			"valid":this.form.invalid,
			"datas":formformated});
		/*
		if (this.clickedAction) {
			this.clickedAction=false;
			this.validatedSubscription=this.valided.subscribe((validation:any) =>{
						
						
						let btn:any= (validation.close)
								?	this.btnSaveClose.nativeElement
							 	:
							 	this.btnSave.nativeElement;
								console.log("valided click",validation,this.clickedAction,btn.disabled)
						if (validation.validate!=undefined
						 && validation.validate
						 && !this.clickedAction
						 ) {
							 
							 this.clickedAction=true;
							 console.log("valided button ",this.btnSaveClose,this.btnSave,this.clickedAction)
							 btn.click();
							 this.myEventSubscription.unsubscribe();
							 
						}
					});
		}*/
		
	}
	private __do__submit__data(formformated: any, btn: any) {
		this.submit.emit(formformated)
		this.onsubmited = true
		btn.disable = false
		this.clickedAction=false;
	}

	private __show__confirm__dialog__(action: any, formformated: any, btn: any) {
		this.dialogService.open(ConfirmComponent, {
			data: {
				action: action,
				status: this.currentEtat,
				dateCreate: this.creationForm
			},
		}, (res: any) => {
			if (res) {
				formformated['NOWORKFLOW'] = false
				if (res === 'Save') {
					this.__handel__form__navigation__(formformated, action)
				}
				this.__do__submit__data(formformated, btn)
			}
		})
	}

	private __handel__form__navigation__(formformated: any, action: any) {
		formformated['close'] = false
		if (action === 'prev') {
			formformated['prev'] = true
		}
		if (action === 'next') {
			formformated['next'] = true
		}
		if (action === 'close') {
			formformated['close'] = true
		}
	}

	private __show__error__dialog__() {
		this.utilities.log(this.form.errors)
		// open error dialog
		this.dialogService.open(FormDialogErrorsComponent, {
			data: this.getFormValidationErrors(this.form.controls)
		})
		//this.clickedAction=false;
	}
   
	onSubmited(item) {
		this.submitedSuccess = false
		if (item.hasOwnProperty('error') && item.error.hasOwnProperty('data'))
			this.payLoad = item.error.data

		if (item.hasOwnProperty('result') && item.result.hasOwnProperty('message')) {
			this.payLoad = item.result.message
			this.submitedSuccess = true
		}
	}

	scrollToCard(elttoswoth:any, event: MouseEvent) {
         let anchor=elttoswoth.id;
         let elt=document.getElementById(anchor);
        let element:HTMLElement = elt as HTMLElement;
        let elmt={
            element: element,
            size: null,
            scroll: this.myScrollContainer
        }
        
       this.myScrollContainer.nativeElement.scrollTop=element.offsetTop;
       //  this.scrolled.emit(elmt);
	}
    
	getFormValidationErrors(controls: any, container?: any): any[] {
		let errors: any[] = []
		Object.keys(controls).forEach(key => {
			const control = controls[key] as FormGroup
			controls[key].markAsTouched()
			if (control instanceof FormGroup) {
				errors = errors.concat(this.getFormValidationErrors(control.controls, key))
			}
			const controlErrors: ValidationErrors = controls[key].errors
			if (controlErrors !== null) {
				this.__handel__errors__(key, container, controlErrors, errors)
			}
		})
		return errors
	}
	private __handel__errors__(key: string, container: any, controlErrors: ValidationErrors, errors: any[]) {
		let label = ''
		_.forEach(this.atylInputsControls, (comp, index) => {
			if (comp.ID == key)
				label = comp.placeholder ? comp.placeholder : comp.label
			if (container) {
				if (container == comp.ID && comp.options.hasOwnProperty(key))
					label = comp.placeholder ? comp.placeholder : comp.label
				if (container == comp.ID && comp.type == key)
					label = comp.placeholder ? comp.placeholder : comp.label
			}
		})
		Object.keys(controlErrors).forEach(keyError => {
			console.log("controlErrors",controlErrors[keyError]);
			errors.push({
				control_name: label,
				error_name: this.errorInputHandler(keyError,controlErrors[keyError]),
				error_value: controlErrors[keyError]
			})
		})
	}

	errorInputHandler(errorname: string,value: any) {
		let label:string='';
		switch(errorname) {
			case "required":
				label='Ce champ est obligatoire';break;
			case "doublons":
				label='Ce champ est en doublons';
				if (Array.isArray(value))
					label+=":<br/>" + value.join(", ");
				break;	
			default:	
				 label='';
		}
		
		
		return label
	}

	onDateChange(event,type){
		this.dateChange.emit({value: event.value,type: type});
	}
	
	@HostListener('onElementReadyEvent', ['$event'])
	onReadyEvent(event:any) {
						//event.stopPropagation();
						event.preventDefault();
						
						//this.form.updateValueAndValidity({ onlySelf: true, emitEvent: true });
						if (this.form.get('uuid')!=undefined)
							this.form.get('uuid').setValue(this._newGuid());
						//console.log("FormAtylComponent onReadyEvent.0",event,this.form,this.form.controls)
						this.ready.emit(event.detail);
	}
	
	iaDialgog() {
		console.log("IaDialogComponent iaDialgog",this.curentForm,this.currentParentForm);
		let ask:string="";
		
		if (this.curentForm.libelle!=undefined && this.curentForm.libelle 
			&& this.curentForm.libelle.length>0 )
			ask="Qu'est que " + this.curentForm.libelle + "?";
		if (this.currentParentForm.form!=undefined && this.currentParentForm.form.libelle!=undefined && this.currentParentForm.form.libelle 
							&& this.currentParentForm.form.libelle.length>0 )
			ask="Qu'est que " + this.currentParentForm.form.libelle + "?";	
			
		this.dialogService.open(IaDialogComponent, {
						data: {
							ask : ask
							},
						width: "80vw",
					 	resizable: false,
					    minimizable: false,
					    draggable: false,
					    maximizable: false
		});
	}


}
